import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import Fade from "@mui/material/Fade";
import { DefaultPrimaryButton } from "@/styles/globalstyles";
import { useMsal } from "@azure/msal-react";
import Copyright from "@/components/Copyright";
import { useEffect } from "react";

const NoPermission = () => {
  const { instance } = useMsal();

  useEffect(() => {
    document.title = "No Permission | AMPA";
  }, []);

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  return (
    <Fade in={true}>
      <Box
        sx={{
          display: "flex",
          width: { xs: "100%", sm: "100%" },
          height: { xs: "80vh", sm: "80vh" },
          alignItems: "center",
          justifyContent: "center",
          borderRadius: { xs: "10px", sm: "10px" },
          p: 4,
        }}
      >
        <Stack
          sx={{
            height: { xs: "100%", sm: "auto" },
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
        >
          <Typography variant="h1">401 Unauthorized</Typography>
          <Typography variant="h2">|</Typography>
          <Typography variant="h2">
            Please sign in again or contact the admin
          </Typography>

          <Button
            variant="contained"
            sx={{ ...DefaultPrimaryButton }}
            onClick={() => {
              handleLogout();
            }}
          >
            Log out
          </Button>
        </Stack>
        <Box sx={{ position: "absolute", bottom: 16 }}>
          <Copyright />
        </Box>
      </Box>
    </Fade>
  );
};

export default NoPermission;
